import { ArrowRightLong } from "../ArrowComponents";
import Badge from "../ArticlePreview/Badge";
import CategorieList from "../CategoriesList";

const ScopriBsNotImg = ({ post, index }) => {
  return (
    <div
      className={`flex bg-black py-20 text-white max-md:!mt-0 sm:py-28 ${
        index % 2 == 0
          ? "justify-end rounded-e-[60px] pl-4 pr-10 max-md:mr-4 md:rounded-e-[100px]"
          : "rounded-s-[60px] pl-10 pr-4 max-md:ms-4 md:rounded-s-[100px]"
      }`}
    >
      <div className="flex w-full max-w-xl flex-col gap-4 md:gap-7 xl:gap-10">
        {post?.meta != null && (
          <div>
            <CategorieList
              categories={post?.meta}
              className="text-2xl uppercase hover:underline max-[319px]:text-base lg:text-3xl xl:text-[45px] xl:leading-tight"
            />
          </div>
        )}
        <h2 className="mt-2 text-4xl font-bold max-[319px]:text-2xl lg:text-6xl xl:text-[85px] xl:leading-none">
          {post.post_title}
        </h2>
        <div>
          <Badge meta={post?.meta} style="border border-white" />
          <ArrowRightLong
            href={`/a/${post.post_name}`}
            color={"white"}
            message={"Scopri di più"}
            divStyles="py-4 max-sm:text-sm sm:text-base md:text-xl"
          />
        </div>
      </div>
    </div>
  );
};

export default ScopriBsNotImg;
